import { render, staticRenderFns } from "./saveCommonQuestion.vue?vue&type=template&id=51fc184f&"
import script from "./saveCommonQuestion.vue?vue&type=script&lang=js&"
export * from "./saveCommonQuestion.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports